import React from 'react';
import type { BioRenderableCandidate } from '@axiom/validation';

import ProfileCheckmark from '../../../public/static/svg/profile-checkmark.svg';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Layout } from '../../layout/Layout/Layout';
import { LayoutItem } from '../../layout/Layout/LayoutItem';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { Well } from '../../layout/Well/Well';

export const doNotShowBannerNames = {
  optedOutDisplay: 'optedOutDisplay',
  limitedFeedbackDisplay: 'limitedFeedbackDisplay',
} as const;

export type CandidateReputationDoNotShowBannerProps = {
  name: (typeof doNotShowBannerNames)[keyof typeof doNotShowBannerNames];
  candidate?: BioRenderableCandidate;
};

export const CandidateReputationDoNotShowBanner = ({
  name,
  candidate,
}: CandidateReputationDoNotShowBannerProps) => {
  const verbage = {
    [doNotShowBannerNames.optedOutDisplay]: `While ${candidate?.calculatedDisplayName ?? 'Talent'} has chosen to keep their feedback private, we are confident in their skills and believe they are a good match for your opportunity.`,
    [doNotShowBannerNames.limitedFeedbackDisplay]:
      'Although client feedback is not yet available for this talent, we are confident they are a great match for your legal needs.',
  } as const;
  return (
    <Gutter top="24px">
      <Well background="light blue" name={name}>
        <Layout horizontalGutter="16px" position="middle">
          <LayoutItem>
            <ProfileCheckmark width="98" height="93" />
          </LayoutItem>
          <Paragraph>{verbage[name]}</Paragraph>
        </Layout>
      </Well>
    </Gutter>
  );
};
